import React, { useEffect, useState, Fragment, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'Components/Button';
import { Grid, Icon } from '@mui/material';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';

import colors from 'Assets/sass/core/vars.scss';

import {
	modalEnableStarterClose,
	catalogProcessItem,
	updateLastReading,
	clearRedux
} from 'Redux/actions';

import './main.scss';

const ModalEnableDisable = (props) => {
	const { messages } = useIntl();
	const dispatch = useDispatch()

	const updateLastReadingLoading = useSelector(state => state.fleetMainRedux.updateLastReadingLoading);
	const updateLastReadingResult = useSelector(state => state.fleetMainRedux.updateLastReadingResult);
	const { isOpen, loading, vehicles } = useSelector(state => state.vehicleEnableDisableRedux);
	const [openConfirmation, setOpenConfirmation] = useState(false);
	const [disabled, setDisabled] = useState(false);
	const [vehiclesList, setVehiclesList] = useState([]);

	useEffect(() => {
		return () => {
			dispatch(clearRedux("MODAL_ENABLE_STARTER"));
			dispatch(clearRedux("STATUS_FLEET", { updateLastReadingLoading: false, updateLastReadingResult: {} }));
		}
	}, []);

	useEffect(() => {
		if(vehicles.length){
			setVehiclesList(vehicles)
		}
	}, [vehicles]);

	useEffect(() => {
		if (updateLastReadingResult?.id && isOpen) {
			const newVehiclesList = vehiclesList?.map(item => item.id == updateLastReadingResult.id? { ...item,desiredStarterState: updateLastReadingResult.desiredStarterState,starterDisabled: updateLastReadingResult.starterDisabled=="Enable"?true:false}: item);
			setVehiclesList(newVehiclesList)
			window.setTimeout(function () {
				let payloadUnit = {
					id: updateLastReadingResult.id,
					desiredStarterState:updateLastReadingResult.desiredStarterState,
					starterDisabled:updateLastReadingResult.desiredStarterState,
					starter: 1
				}
				dispatch(catalogProcessItem("Unit", { ...payloadUnit }));

			}, 3000);
		}

	}, [updateLastReadingResult, isOpen]);

	const getStarterState = useCallback((lastReading) => {
		let color = colors?.color_disabled_gray;
		let message = '';

		if (lastReading) {
			if (!lastReading.starterSupported || lastReading.starterSupported === "false") {
				//color = '#727272';
				message = messages["fleet_starter_not_supported"]
			} else {
				message = lastReading.desiredStarterState === "Enable"?messages["fleet_starter_enable"]:messages["fleet_starter_disable"];
			}
		} else {
			//color = 'vanillaGray'
			message = messages["unknown"];
		}

		return <span style={{ color: color, fontSize: 14 }}>{message}</span>
	});

	const getOperationStatus = useCallback((vehicle) => {
		if (updateLastReadingResult?.id) {
			return <Icon className="green" fontSize="small">check</Icon>
		}

		return "";
	});

	const handleClose = useCallback(() => {
		dispatch(modalEnableStarterClose());
		dispatch(clearRedux("MODAL_ENABLE_STARTER"));
		dispatch(clearRedux("STATUS_FLEET", { updateLastReadingLoading: false, updateLastReadingResult: {} }));
	});

	let disableConfirmation = disabled ? messages['fleet_starter_disable_confirmation'] : messages['fleet_starter_enable_confirmation'];

	const title = `${messages['fleetModal_titleModalEnableDisable']} ${vehiclesList?.length > 1 ? `(${vehiclesList?.length} ${messages['fleetModal_units']})` : ''}`;

	return (
		<React.Fragment>
			<Modal
				open={isOpen}
				handleClose={handleClose}
				title={title}
				position="right"
				size="small"
				loading={loading || updateLastReadingLoading}
			>
				<ModalBody>
					<div style={{ padding: 24 }}>
						<Grid
							container
							direction="row"
							justifyContent="space-between"
							alignItems="flex-start"
							style={{ marginBottom: 20 }}
						>
							<Grid item xs={7}>
								{messages['fleet_starter_vehicles']}
							</Grid>
							<Grid item xs={4} style={{ textAlign: 'right' }}>
								{messages['vehicleStatusModal_currentStatus']}
							</Grid>
							<Grid item xs={1}>

							</Grid>
						</Grid>

						{
							vehiclesList && vehiclesList.map((vehicle, index) => {
								return (
									<Grid
										key={index}
										container
										direction="row"
										justifyContent="space-between"
										alignItems="center"
										style={{ margin: "10px 0px 10px 0px" }}
									>
										<Grid item xs={7}>
											<b>{vehicle.label}</b>
										</Grid>
										<Grid item xs={4} style={{ textAlign: 'right' }}>
											{getStarterState(vehicle)}
										</Grid>
										<Grid item xs={1} style={{ paddingLeft: 10 }}>
											{getOperationStatus(vehicle)}
										</Grid>
									</Grid>
								);
							})
						}
					</div>
				</ModalBody>

				<ModalFooter>
					<div>
						<Button
							type="button"
							onClick={handleClose}
							className="btn-cancel"
						>
							{messages["cancel"]}
						</Button>

						<Button
							disabled={!vehiclesList?.filter(vehicle => vehicle.starterSupported).length > 0 || loading || updateLastReadingLoading}
							className="btn-blue"
							onClick={() => {
								setOpenConfirmation(true)
								setDisabled(true);
							}}
						>
							{messages['disable']}
						</Button>

						<Button
							disabled={!vehiclesList?.filter(vehicle => vehicle.starterSupported).length > 0 || loading || updateLastReadingLoading}
							className="btn-blue"
							onClick={() => {
								setOpenConfirmation(true)
								setDisabled(false);
							}}
						>
							{messages['enable']}
						</Button>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				open={openConfirmation}
				title={messages['fleetModal_titleModalEnableDisable']}
				//position="right"
				size="small"
				style={{ overflow: 'hidden', height: 300, top: '30%' }}
				className="overflow-hidden"
				handleClose={() => setOpenConfirmation(false)}
			>
				<ModalBody
					style={{
						overflow: 'hidden',
						marginBottom: 0
					}}
				>
					<div
						style={{
							padding: "0px 24px 24px 24px"
						}}
					>
						<p>
							<strong>
								{disableConfirmation.replace("{number_units}", vehiclesList.filter(vehicle => vehicle.starterSupported && vehicle.starterSupported != "false").length)}
							</strong>
						</p>
					</div>
				</ModalBody>

				<ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
					<Button
						onClick={() => setOpenConfirmation(false)}
						className="btn-cancel"
					>
						{messages['cancel']}
					</Button>

					<Button
						disabled={!vehiclesList?.filter(vehicle => vehicle.starterSupported).length > 0 || loading || updateLastReadingLoading}
						className="btn-blue"
						onClick={() => {
							vehiclesList.map(vehicle => {
								if (vehicle.starterSupported && vehicle.starterSupported != "false") {
									dispatch(updateLastReading({ deviceId: vehicle.id, desiredStarterState: disabled ? false : true }));
								}
							});

							setOpenConfirmation(false);
						}}
					>
						{disabled ? messages['disable'] : messages['enable']}
					</Button>
				</ModalFooter>
			</Modal>
		</React.Fragment>
	);
};

export default ModalEnableDisable;